// /s/:packId/files — BJddk viewer 模式(深链;未订阅显示订阅引导,订阅按钮跳回 /s/ 主页走支付流)。
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { apiClient, SharePackRoute, Spinner } from '@dogdisk/shared'
import { MobileScreen } from '../components/mobile-screen'
import { PackFilesView, type PackFileRow } from '../components/pack-files-view'
import { usePackBasePath } from '../_lib/pack-route'
import { useGoBack } from '../_lib/use-go-back'

function Inner({ packId, priceCoin }: { packId: string; priceCoin: number | null }) {
  const navigate = useNavigate()
  const base = usePackBasePath()
  // 顶层返回走浏览器 history 弹栈(与详情页一致),避免 push 导致两页死循环。
  const goBack = useGoBack(`${base}/${packId}`)
  const [items, setItems] = useState<PackFileRow[] | null>(null)
  const [probing, setProbing] = useState(true)
  const probed = useRef(false)
  useEffect(() => {
    if (probed.current) return
    probed.current = true
    void apiClient
      // 未订阅返 401 TOKEN_INVALID → PackFilesView 走 preview 兜底;
      // 只静默 TOKEN_INVALID(否则非订阅者进场误弹「令牌无效」);5xx/网络错仍弹。
      .get<{ items: { id: string; name: string; type: string; size_original: number | null; mime_type: string | null; cover_thumb_url?: string | null }[] }>(
        `/gapi/public/share/${packId}/items`,
        { silenceErrorCodes: ['TOKEN_INVALID'] },
      )
      .then((res) =>
        setItems(
          res.items.map((it) => ({
            key: it.id,
            itemId: it.id,
            name: it.name,
            type: it.type,
            size: it.size_original,
            mimeType: it.mime_type,
            coverThumbUrl: it.cover_thumb_url ?? null,
          })),
        ),
      )
      .catch(() => {}) // 未订阅 → PackFilesView 走 preview(rows undefined)
      .finally(() => setProbing(false))
  }, [packId])
  if (probing) return null
  return (
    <PackFilesView
      onBack={goBack}
      packId={packId}
      rows={items ?? undefined}
      subscribeBar={
        items === null && priceCoin != null
          ? { priceCoin, onSubscribe: () => navigate(`${base}/${packId}`) }
          : undefined
      }
      onRowClick={undefined}
    />
  )
}

export function PackFilesPage() {
  const { packId } = useParams<{ packId: string }>()
  return (
    <SharePackRoute
      renderLoading={() => (
        <MobileScreen>
          <div className="flex flex-1 items-center justify-center"><Spinner className="text-gray-400" /></div>
        </MobileScreen>
      )}
      renderError={() => (
        <MobileScreen>
          <div className="flex flex-1 items-center justify-center text-[14px] text-[#FF6B6B]">资源包不存在或已失效</div>
        </MobileScreen>
      )}
      renderPage={(meta) => <Inner packId={packId!} priceCoin={meta.price_coin ?? null} />}
    />
  )
}
